
import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Button } from '@mui/material';

import DandDAPI from "@dndUtilities/system_api";

import NonFSIndex from "@dndComponents/NonFSIndex";
import AddButton from "@components/input/buttons/AddButton";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import SpellManager from "@dndViews/spell/SpellManager";
// import DisplayObjects from '../../components/display/DisplayObjects';

const api = DandDAPI.getInstance();

export default function SpellIndex() {
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [open, setOpen] = useState(false);

  const renderExtras = () => {
    return (
      <>
        <ModalOrDrawer
          open={open}
          width={800}
          onClose={() => { setOpen(false); }}>
          <SpellManager />
        </ModalOrDrawer>
      </>
    );
  }
  
  if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else {
    return (
      <>
        <NonFSIndex
          data_type="spell"
          // save_all
          // name_display={(obj: ModelBase | PlayerObject) => {
          //   if (obj instanceof Spell) {
          //     return (
          //       <ViewSpell
          //         spell={obj}
          //         show_ritual
          //         hide_details
          //       />
          //     );
              
          //     // return <>{ obj.use_name } (<DisplayObjects type='source_book' ids={obj.source_book_ids} />)</>;
          //   }
          //   return <></>;
          // }}
          extra_by_add={api.user && api.user.admin ? () => {
            // debugger;
            return (
              <>
                &nbsp;
                <AddButton
                  label="Parse Add"
                  onClick={() => {
                    setNavigateTo(`/dandd/spell/parse_add`);
                  }}
                />
                &nbsp;
                <Button
                  variant="contained" color="primary" 
                  onClick={() => {
                    setOpen(true);
                  }}>
                  Spell Manager
                </Button>
              </>
            );
          } : undefined}
          // save_all
          // extra_filter={(obj: ModelBase | PlayerObject) => {
          //   if (obj instanceof Spell) {
          //     return !obj.twinnable_1dd_ua7 && obj.description.includes("dditional") && obj.level > 4;
          //     // const dominant = api.smart_hash.spell.find(o => o.variant_group_id === obj.variant_group_id && o.is_dominant);
          //     // return dominant === undefined || !dominant.source_book_ids.includes("6675b302a4476741138fa22b") || obj.source_book_ids.includes("6675b302a4476741138fa22b");
          //   }
          //   return false;
          // }}
          // log_it
          // sort={(obj1: ModelBase | PlayerObject, obj2: ModelBase | PlayerObject) => {
          //   if (obj1 instanceof Spell && obj2 instanceof Spell) {
          //     // return obj1.true_name.localeCompare(obj2.true_name);
          //     return obj1.level > obj2.level ? 1 : (obj1.level === obj2.level ? 0 : -1);
          //   }
          //   return 0;
          // }}
          quick_fields={["school","spell_level","spell_list"]}
        />
        { renderExtras() }
      </>
    );
  }
}